import { PayloadAction } from "@reduxjs/toolkit";

import { CarsState } from '../../types';

export const setCarLocationHistorySharingSelectedLocation = (
  state: CarsState,
  action: PayloadAction<CarsState['locationHistorySharing']['selectedLocation']>
) => {
  state.locationHistorySharing.selectedLocation = action.payload
}
